// Override Settings
var bcSfFilterSettings = {
    general: {
        limit: bcSfFilterConfig.custom.products_per_page,
        // Optional
        loadProductFirst: true,
        activeFilterScrollbar: 'browser'
    }
};

var bcSfFilterTemplate = {
    'vendorHtml': '<p class="product-list-item-vendor"><a href="{{itemVendorUrl}}">{{itemVendorLabel}}</a></p>',

    // Grid Template
    'productGridItemHtml':  '<article class="product-list-item" id="product-list-item-{{itemId}}" data-product-id="{{itemId}}">' +
                                '<figure class="product-list-item-thumbnail {{itemFlipImageClass}}" data-url="{{itemUrl}}" style="{{itemFlipImageUrl}}">' +
                                    '<a href="{{itemUrl}}"><img src="{{itemThumbUrl}}" /></a>' +
                                    '{{itemHover}}' +
                                    '{{itemLabels}}' +
                                '</figure>' +
                                '<div class="product-list-item-details">' +
                                    '{{itemVendor}}' +
                                    '<h2 class="product-list-item-title"><a href="{{itemUrl}}">{{itemTitle}}</a></h2>' +
                                    '<p class="product-list-item-price">{{itemPrice}}</p>' +
                                '</div>' +
                            '</article>',

    // Pagination Template
    'previousHtml': '<li class="previous"><a href="{{itemUrl}}"></a></li>',
    'nextHtml': '<li class="next"><a href="{{itemUrl}}"></a></li>',
    'pageItemHtml': '<li><a href="{{itemUrl}}" title="">{{itemTitle}}</a></li>',
    'pageItemSelectedHtml': '<li class="active"><a href="" title="">{{itemTitle}}</a></li>',
    'pageItemRemainHtml': '<li class="ellipsis">{{itemTitle}}</li>',
    'paginateHtml': '{{previous}}{{pageItems}}{{next}}',

    // Sorting Template
    'sortingHtml': '<span class="selected-text"></span><select>{{sortingItems}}</select>',
};

// Build Product List
BCSfFilter.prototype.buildProductGridItem = function(data, index, totalProduct) {
     /*** Prepare data ***/
    var images = data.images_info;
    data.price_min *= 100, data.price_max *= 100, data.compare_at_price_min *= 100, data.compare_at_price_max *= 100; // Displaying price base on the policy of Shopify, have to multiple by 100
    var soldOut = !data.available; // Check a product is out of stock
    var onSale = data.compare_at_price_min > data.price_min; // Check a product is on sale
    var priceVaries = data.price_min != data.price_max; // Check a product has many prices
    // Get First Variant (selected_or_first_available_variant)
    var firstVariant = data['variants'][0];
    if (getParam('variant') !== null && getParam('variant') != '') {
        var paramVariant = data.variants.filter(function(e) { return e.id == getParam('variant'); });
        if (typeof paramVariant[0] !== 'undefined') firstVariant = paramVariant[0];
    } else {
        for (var i = 0; i < data['variants'].length; i++) {
            if (data['variants'][i].available) {
                firstVariant = data['variants'][i];
                break;
            }
        }
    }
    /*** End Prepare data ***/

    // Get Template
    var itemHtml = bcSfFilterTemplate.productGridItemHtml;    

    // Add Thumbnail
    var images = Object.keys(data.images).map(function (key) { return data.images[key]; });
    var itemThumbUrl = images.length > 0 ? this.optimizeImage(images[0]) : bcSfFilterConfig.general.no_image_url;
    var itemFlipImageUrl = images.length > 1 ? this.optimizeImage(images[1]) : itemThumbUrl;
    itemHtml = itemHtml.replace(/{{itemThumbUrl}}/g, itemThumbUrl);

    // Add Flip Image
    var hasFlipImage = bcSfFilterConfig.custom.product_hover == 'image-flip' ? true : false;
    itemHtml = itemHtml.replace(/{{itemFlipImageClass}}/g, hasFlipImage ? 'has-secondary-image' : '');
    itemHtml = itemHtml.replace(/{{itemFlipImageUrl}}/g, hasFlipImage ? 'background-image:url(' + itemFlipImageUrl + ')' : '');

    // Add Quick view
    var itemHoverHtml = '';
    if (bcSfFilterConfig.custom.product_hover == 'quick-shop') {
        itemHoverHtml += '<script type="application/json" data-product-json>{{itemProductJson}}</script>';
        itemHoverHtml += '<script type="application/json" data-product-settings-json>';
        itemHoverHtml += '{';
        itemHoverHtml += '"addToCartText": ' + JSON.stringify(bcSfFilterConfig.label.add_to_cart) + ',';
        itemHoverHtml += '"enableHistory": ' + JSON.stringify(bcSfFilterConfig.label.enable_history) + ',';
        itemHoverHtml += '"imageZoom": false,';
        itemHoverHtml += '"linkedOptions": false,';
        itemHoverHtml += '"processingText": ' + JSON.stringify(bcSfFilterConfig.label.processing) + ',';
        itemHoverHtml += '"ajaxAddProduct": true,';
        itemHoverHtml += '"setQuantityText": ' + JSON.stringify(bcSfFilterConfig.label.set_quantity) + ',';
        itemHoverHtml += '"soldOutText": ' + JSON.stringify(bcSfFilterConfig.label.sold_out) + ',';
        itemHoverHtml += '"unavailableText": ' + JSON.stringify(bcSfFilterConfig.label.unavailable);
        itemHoverHtml += '}';
        itemHoverHtml += '</script>';
        itemHoverHtml += '<span class="quick-shop-modal-trigger" data-product-handle="{{itemHandle}}" data-product-id="{{itemId}}" data-variant-id="' + firstVariant['id'] + '" data-vendor-url="{{itemVendorLabel}}">' + bcSfFilterConfig.label.quick_shop + '</span>';
    } else if (bcSfFilterConfig.custom.product_hover == 'stock-level') {
        if (!soldOut) {
            var total = 0;
            var threshold = bcSfFilterConfig.custom.product_stock_level_threshold * 1;
            var infinity = false;
            for (var k in data.variants) {
                var variant = data['variants'][k];
                if (variant.inventory_management == null) {
                    infinity = true;
                } else if (variant.inventory_management == '') {
                    infinity = true;
                } else if (variant.inventory_management == 'shopify' && variant.inventory_policy == 'continue') {
                    infinity = true
                } else if (infinity == false) {
                    var temp = total + variant.inventory_quantity;
                    var total = temp * 1;
                }
            }

            if (infinity == false && total < threshold) {
                itemHoverHtml += '<a class="product-list-item-inventory" href="{{itemUrl}}">';
                itemHoverHtml += bcSfFilterConfig.label.stock_indicator_message.replace(/{{ num }}/g, total);
                itemHoverHtml += '</a>';
            }
        }
    }
    itemHtml = itemHtml.replace(/{{itemHover}}/g, itemHoverHtml);

    // Add Label
    var itemLabelsHtml = '';
    if (bcSfFilterConfig.custom.product_badges) {
        var iconClass = bcSfFilterConfig.custom.product_icons ? 'product-icons' : '';
        if (soldOut) {
            itemLabelsHtml += '<span class="product-list-item-unavailable ' + iconClass + ' " data-title="' + bcSfFilterConfig.label.sold_out + '"></span>';            
        } else {
            if (onSale) {
                itemLabelsHtml += '<span class="product-list-item-on-sale ' + iconClass + '" data-title="' + bcSfFilterConfig.label.sale + '"></span>';
            }
        }
    }
    itemHtml = itemHtml.replace(/{{itemLabels}}/g, itemLabelsHtml);
    
    // Add Vendor
    var itemVendorHtml = bcSfFilterConfig.custom.vendor_enable ? bcSfFilterTemplate.vendorHtml : '';
    itemHtml = itemHtml.replace(/{{itemVendor}}/g, itemVendorHtml);

    // Add price
    var itemPriceHtml = '';
    if (priceVaries) {
        itemPriceHtml += bcSfFilterConfig.label.from_price;
    }
    itemPriceHtml += '<span class="money">' + this.formatMoney(data.price_min, this.moneyFormat) + '</span>';
    if (onSale) {
        itemPriceHtml += '<span class="original money">' + this.formatMoney(data.compare_at_price_min, this.moneyFormat) + '</span>';
    }
    itemHtml = itemHtml.replace(/{{itemPrice}}/g, itemPriceHtml);

    // Add main attribute
    itemHtml = itemHtml.replace(/{{itemId}}/g, data.id);
    itemHtml = itemHtml.replace(/{{itemHandle}}/g, data.handle);
    itemHtml = itemHtml.replace(/{{itemTitle}}/g, data.title);
    itemHtml = itemHtml.replace(/{{itemVendorLabel}}/g, data.vendor);
    itemHtml = itemHtml.replace(/{{itemVendorUrl}}/g, this.buildProductItemVendorUrl(data.vendor));
    itemHtml = itemHtml.replace(/{{itemProductJson}}/g, JSON.stringify(data));
    itemHtml = itemHtml.replace(/{{itemUrl}}/g, this.buildProductItemUrl(data));

    return itemHtml;
}

// Customize data to suit the data of Shopify API
BCSfFilter.prototype.prepareProductData = function(data) {
    for (var k in data) {
        // Featured image
        if (data['images_info'] > 0) {
            data[k]['featured_image'] = data['images_info'][0];
        } else {
            data[k]['featured_image'] = {width: '', height: '', aspect_ratio: 0}
        }

        // Add Options
        var optionsArr = [];
        for (var i in data[k]['options_with_values']) {
            optionsArr.push(data[k]['options_with_values'][i]['name']);
        }
        data[k]['options'] = optionsArr;

        // Customize variants
        for (var i in data[k]['variants']) {
            var variantOptionArr = [];
            var count = 1;
            var variant = data[k]['variants'][i];
            // Add Options
            var variantOptions = variant['merged_options'];
            if (Array.isArray(variantOptions)) {
                for (var j = 0; j < variantOptions.length; j++) {
                    var temp = variantOptions[j].split(':');
                    data[k]['variants'][i]['option' + (parseInt(j) + 1)] = temp[1];
                    data[k]['variants'][i]['option_' + temp[0]] = temp[1];
                    variantOptionArr.push(temp[1]);
                }
                data[k]['variants'][i]['options'] = variantOptionArr;
            }
            data[k]['variants'][i]['compare_at_price'] = parseFloat(data[k]['variants'][i]['compare_at_price']) * 100;
            data[k]['variants'][i]['price'] = parseFloat(data[k]['variants'][i]['price']) * 100;
        }

        // Add Description
        data[k]['description'] = data[k]['body_html'];
    }
    return data;
};

// Build Pagination
BCSfFilter.prototype.buildPagination = function(totalProduct) {
    // Get page info
    var currentPage = parseInt(this.queryParams.page);
    var totalPage = Math.ceil(totalProduct / this.queryParams.limit);

    // If it has only one page, clear Pagination
    if (totalPage == 1) {
        jQ(this.selector.bottomPagination).html('');
        return false;
    }

    if (this.getSettingValue('general.paginationType') == 'default') {
        var paginationHtml = bcSfFilterTemplate.paginateHtml;

        // Build wrapper
        paginationHtml = paginationHtml.replace(/{{paginateWrapperClass}}/g, 'twelve');

        // Build Previous
        var previousHtml = (currentPage > 1) ? bcSfFilterTemplate.previousHtml : '';
        previousHtml = previousHtml.replace(/{{itemUrl}}/g, this.buildToolbarLink('page', currentPage, currentPage -1));
        paginationHtml = paginationHtml.replace(/{{previous}}/g, previousHtml);

        // Build Next
        var nextHtml = (currentPage < totalPage) ? bcSfFilterTemplate.nextHtml : '';
        nextHtml = nextHtml.replace(/{{itemUrl}}/g, this.buildToolbarLink('page', currentPage, currentPage + 1));
        paginationHtml = paginationHtml.replace(/{{next}}/g, nextHtml);

        // Create page items array
        var beforeCurrentPageArr = [];
        for (var iBefore = currentPage - 1; iBefore > currentPage - 3 && iBefore > 0; iBefore--) {
            beforeCurrentPageArr.unshift(iBefore);
        }
        if (currentPage - 4 > 0) {
            beforeCurrentPageArr.unshift('...');
        }
        if (currentPage - 4 >= 0) {
            beforeCurrentPageArr.unshift(1);
        }
        beforeCurrentPageArr.push(currentPage);

        var afterCurrentPageArr = [];
        for (var iAfter = currentPage + 1; iAfter < currentPage + 3 && iAfter <= totalPage; iAfter++) {
            afterCurrentPageArr.push(iAfter);
        }
        if (currentPage + 3 < totalPage) {
            afterCurrentPageArr.push('...');
        }
        if (currentPage + 3 <= totalPage) {
            afterCurrentPageArr.push(totalPage);
        }

        // Build page items
        var pageItemsHtml = '';
        var pageArr = beforeCurrentPageArr.concat(afterCurrentPageArr);
        for (var iPage = 0; iPage < pageArr.length; iPage++) {
            if (pageArr[iPage] == '...') {
                pageItemsHtml += bcSfFilterTemplate.pageItemRemainHtml;
            } else {
                pageItemsHtml += (pageArr[iPage] == currentPage) ? bcSfFilterTemplate.pageItemSelectedHtml : bcSfFilterTemplate.pageItemHtml;
            }
            pageItemsHtml = pageItemsHtml.replace(/{{itemTitle}}/g, pageArr[iPage]);
            pageItemsHtml = pageItemsHtml.replace(/{{itemUrl}}/g, this.buildToolbarLink('page', currentPage, pageArr[iPage]));
        }
        paginationHtml = paginationHtml.replace(/{{pageItems}}/g, pageItemsHtml);

        jQ(this.selector.bottomPagination).html(paginationHtml);
    }

    var from = this.queryParams.page == 1 ? this.queryParams.page : (this.queryParams.page - 1) * this.queryParams.limit + 1;
    var to = this.queryParams.page * this.queryParams.limit;
    jQ(this.selector.bottomPagination).find('.count').html(bcSfFilterConfig.label.showing_items + from + '-' + to + ' of ' + totalProduct);
};

// Build Sorting
BCSfFilter.prototype.buildFilterSorting = function() {
    if (bcSfFilterTemplate.hasOwnProperty('sortingHtml')) {
        jQ(this.selector.topSorting).html('');

        var sortingArr = this.getSortingList();
        if (sortingArr) {
            // Build content 
            var sortingItemsHtml = '';
            for (var k in sortingArr) {
                sortingItemsHtml += '<option value="' + k +'">' + sortingArr[k] + '</option>';
            }
            var html = bcSfFilterTemplate.sortingHtml.replace(/{{sortingItems}}/g, sortingItemsHtml);
            jQ(this.selector.topSorting).html(html);

            // Set current value
            jQ(this.selector.topSorting + ' select').val(this.queryParams.sort);
            jQ(this.selector.topSorting + ' .selected-text').html(sortingArr[this.queryParams.sort]);
        }
    }
};

// Add additional feature for product list, used commonly in customizing product list
BCSfFilter.prototype.buildExtrasProductList = function(data) {
    $(function() {
        window.theme = new ThemeView();
        return theme.render();
    });
};

// Build additional elements
BCSfFilter.prototype.buildAdditionalElements = function(data, eventType) {};

// Build Breadcrumb
BCSfFilter.prototype.buildBreadcrumb = function(colData, apiData) {
    if (typeof colData !== 'undefined' && colData.hasOwnProperty('collection')) {
        var colInfo = colData.collection;
        var breadcrumbHtml = '<a href="/">' + bcSfFilterConfig.label.breadcrumb_home + '</a>';
        breadcrumbHtml += ' <span class="divider">/</span>';
        breadcrumbHtml += ' <a href="/collections">' + bcSfFilterConfig.label.breadcrumb_header + '</a>';
        breadcrumbHtml += ' <span class="divider">/</span>';
        breadcrumbHtml += ' <span>' + colInfo.title + '</span>';
        jQ('.breadcrumbs').html(breadcrumbHtml);
    }
};


/* Start Fix version 2.3.2 */
BCSfFilter.prototype.addFilterTreeItem=function(e,r,t,i){e=jQ.parseHTML(e),i=void 0!==i?i:this.getSelector("filterTree");void 0!==r&&"before"==r?jQ(i+t).prepend(e):jQ(i+t).append(e)};
/* End Fix version 2.3.2 */

// Fix image url issue of swatch option
function getFilePath(fileName, ext, version) {
    var self = bcsffilter;
    var ext = typeof ext !== 'undefined' ? ext : 'png';
    var version = typeof version !== 'undefined' ? version : '1';
    var prIndex = self.fileUrl.lastIndexOf('?');
    if (prIndex > 0) {
        var filePath = self.fileUrl.substring(0, prIndex);
    } else {
        var filePath = self.fileUrl;
    }
    filePath += fileName + '.' + ext + '?v=' + version;
    return filePath;
}

// Build Default layout
BCSfFilter.prototype.buildDefaultElements=function(){var isiOS=/iPad|iPhone|iPod/.test(navigator.userAgent)&&!window.MSStream,isSafari=/Safari/.test(navigator.userAgent),isBackButton=window.performance&&window.performance.navigation&&2==window.performance.navigation.type;if(!(isiOS&&isSafari&&isBackButton)){var self=this,url=window.location.href.split("?")[0],searchQuery=self.isSearchPage()&&self.queryParams.hasOwnProperty("q")?"&q="+self.queryParams.q:"";window.location.replace(url+"?view=bc-original"+searchQuery)}};


BCSfFilter.prototype.getFilterData=function(eventType,errorCount){function BCSend(eventType,errorCount){var self=bcsffilter;var errorCount=typeof errorCount!=="undefined"?errorCount:0;self.showLoading();if(typeof self.buildPlaceholderProductList=="function"){self.buildPlaceholderProductList(eventType)}self.beforeGetFilterData(eventType);self.prepareRequestParams(eventType);self.queryParams["callback"]="BCSfFilterCallback";self.queryParams["event_type"]=eventType;var url=self.isSearchPage()?self.getApiUrl("search"):self.getApiUrl("filter");var script=document.createElement("script");script.type="text/javascript";var timestamp=(new Date).getTime();script.src=url+"?t="+timestamp+"&"+jQ.param(self.queryParams);script.id="bc-sf-filter-script";script.async=true;var resendAPITimer,resendAPIDuration;resendAPIDuration=2e3;script.addEventListener("error",function(e){if(typeof document.getElementById(script.id).remove=="function"){document.getElementById(script.id).remove()}else{document.getElementById(script.id).outerHTML=""}if(errorCount<3){errorCount++;if(resendAPITimer){clearTimeout(resendAPITimer)}resendAPITimer=setTimeout(self.getFilterData("resend",errorCount),resendAPIDuration)}else{self.buildDefaultElements(eventType)}});document.getElementsByTagName("head")[0].appendChild(script);script.onload=function(){if(typeof document.getElementById(script.id).remove=="function"){document.getElementById(script.id).remove()}else{document.getElementById(script.id).outerHTML=""}}}this.requestFilter(BCSend,eventType,errorCount)};BCSfFilter.prototype.requestFilter=function(sendFunc,eventType,errorCount){sendFunc(eventType,errorCount)};


/* start-boost-2.4.8 */
BCSfFilter.prototype.buildFilterOptionItem=function(html,iLabel,iValue,fOType,fOId,fOLabel,fODisplayType,fOSelectType,fOItemValue,fOData){var keepValuesStatic=fOData.hasOwnProperty("keepValuesStatic")?fOData.keepValuesStatic:false;if(fOType=="review_ratings"&&this.getSettingValue("general.ratingSelectionStyle")=="text"){var title=this.getReviewRatingsLabel(fOItemValue.from)}else{var title=this.customizeFilterOptionLabel(iLabel,fOData.prefix,fOType)}if(keepValuesStatic===true)var productNumber=null;else var productNumber=fOItemValue.hasOwnProperty("doc_count")?fOItemValue.doc_count:0;html=html.replace(/{{itemLabel}}/g,this.buildFilterOptionLabel(iLabel,productNumber,fOData));html=html.replace(/{{itemLink}}/g,this.buildFilterOptionLink(fOId,iValue,fOType,fODisplayType,fOSelectType,keepValuesStatic));html=html.replace(/{{itemValue}}/g,encodeURIParamValue(iValue));html=html.replace(/{{itemTitle}}/g,title);html=html.replace(/{{itemFunc}}/g,"onInteractWithFilterOptionValue(event, this, '"+fOType+"', '"+fODisplayType+"', '"+fOSelectType+"', '"+keepValuesStatic+"')");html=this.checkFilterOptionSelected(fOId,iValue,fOType,fODisplayType)?html.replace(/{{itemSelected}}/g,"selected"):html.replace(/{{itemSelected}}/g,"");var htmlElement=jQ(html);htmlElement.children().attr({"data-id":fOId,"data-value":encodeURIParamValue(iValue),"data-parent-label":fOLabel,"data-title":title,"data-count":productNumber});if(fOType!="collection"){htmlElement.children().attr("rel","nofollow")}if(fOType=="collection")htmlElement.children().attr("data-collection-scope",fOItemValue.key);return jQ(htmlElement)[0].outerHTML};
/* end-boost-2.4.8 */

/* Begin patch boost-010 run 2 */
BCSfFilter.prototype.initFilter=function(){return this.isBadUrl()?void(window.location.href=window.location.pathname):(this.updateApiParams(!1),void this.getFilterData("init"))},BCSfFilter.prototype.isBadUrl=function(){try{var t=decodeURIComponent(window.location.search).split("&"),e=!1;if(t.length>0)for(var i=0;i<t.length;i++){var n=t[i],a=(n.match(/</g)||[]).length,r=(n.match(/>/g)||[]).length,o=(n.match(/alert\(/g)||[]).length,h=(n.match(/execCommand/g)||[]).length;if(a>0&&r>0||a>1||r>1||o||h){e=!0;break}}return e}catch(l){return!0}};
/* End patch boost-010 run 2 */
